import { Route, Routes } from "react-router-dom";

import { FeedbackReportDetails } from "./FeedbackReportDetails";
import { FeedbackReportsList } from "./FeedbackReportsList";

export const FeedbackReports = () => (
  <Routes>
    <Route path="" element={<FeedbackReportsList />} />
    <Route path=":reportUuid" element={<FeedbackReportDetails />} />
  </Routes>
);
